//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BModal } from 'bootstrap-vue'

export default {

    name: 'CreateMeetingModal',

    components:  { BModal },

    props: {
    },

    data() {
        return {
            step: 'date',
            timezones: [],
            dateData: {},
            contactData: {},
            company: {},
        }
    },

    created() {
        this.$bus.$on('request-meeting', this.onRequestMeeting)
    },

    destroyed() {
        this.$bus.$off('request-meeting', this.onRequestMeeting)
    },

    methods: {

        onRequestMeeting(company) {
            this.company = company
            this.$refs['modalCreateMeeting'].show()
        },

        onDateNext(data) {
            this.step = 'contact'
            this.dateData = data
        },

        onContactBack(data) {

            this.contactData = data
            this.step = 'date'
        },

        onSubmit(data) {

            this.contactData = data

            const formData = {
                destination_id: this.company.destination_id,

                duration: this.dateData.duration,
                timezone: this.dateData.timezone,
                dates: this.dateData.dates,

                firstName: this.contactData.firstName,
                lastName: this.contactData.lastName,
                email: this.contactData.email,
                eventName: this.contactData.eventName,
                eventDescription: this.contactData.eventDescription,
            }

            this.$axios.$post(this.$ziggy.route('api.profile.meeting.send'), formData, { progress: false })
                .then((response) => {

                    this.$logger.debug('send meeting', response)

                    this.$bus.$emit('alert/show', 'Meeting request sent.', 5, 'sent')

                    //this.hideModal('submit')

                })
                .catch((e) => {

                    let message
                    const exception = e.response.data.exception

                    if(exception == 'Illuminate\\Http\\Exceptions\\ThrottleRequestsException') {
                        message = e.response.data.message
                    } else {
                        message = 'Something went wrong. Please try again later.'
                    }

                    this.$bus.$emit('alert/show', message, 5, 'error', 'danger')
                    this.$logger.captureException(e)
                })
                .then(() => {
                    this.$waiter.end('search/submit-request')
                })

        },

        resetData() {
            this.step = 'date'
            this.dateData = {}
            this.contactData = {}
        },

        showMsgBoxConfirm() {
            this.$bvModal.msgBoxConfirm('Close meeting request?', {
                //title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: true,
                centered: true
            })
                .then(confirmed => {

                    if(confirmed) {
                        this.hideModal('confirmBox')
                    }

                })
                .catch(err => {
                    // An error occurred
                })
        },

        showModal: function () {
            this.$refs['modalCreateMeeting'].show()
        },

        hideModal: function (trigger) {
            this.$refs['modalCreateMeeting'].hide(trigger)
        },

        onHide: function(event) {

            if(event.trigger !== 'confirmBox' && event.trigger !== 'submit') {
                event.preventDefault()
                this.showMsgBoxConfirm()
            }
        },

        onHidden: function () {
            this.resetData()
        },

        onShow: function () {

            if(this.$helper.isEmpty(this.timezones)) {
                this.getTimezones()
            }

        },

        getTimezones: async function () {

            try {
                const response = await this.$axios.$get(this.route('api.content.timezones.data'))
                this.timezones = response

            } catch (e) {
                this.$logger.captureException(e)
            }

        },


    },

}

